import React from 'react';
import { Div, Button, Image } from '@kizi/core-components';

import { IProduct, useField } from '@kizi/comparator-core';
import { TabView } from '@kizi/shared-components';
import { Price } from '../../Price';
import { Desktop, Mobile } from '../../../utils/breakpoint';
import { getLabel } from '../../../utils/translations';
import { useHandleSubmitClick } from '../../../utils/global';

interface ModalProps {
  data: IProduct;
  selectedTabIndex?: number;
  tabs: { label: string; content: JSX.Element }[];
}
export const Modal: React.FC<ModalProps> = ({
  tabs,
  selectedTabIndex,
  data,
}) => {
  const { image, provider, priceInfo, affiliateUrl } = data;

  const shouldOpenNewTab = Boolean(affiliateUrl);
  const handleClick = useHandleSubmitClick(shouldOpenNewTab, data, 5);

  const filtersField = useField('overview.filters');
  // eslint-disable-next-line no-prototype-builtins
  if (!filtersField || !filtersField.hasOwnProperty('value')) return null;
  const filters = JSON.parse(filtersField.value as string);

  if (!filters) return null;

  const header = (
    <Div
      mb={3}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Div display="flex" maxWidth={100}>
        <Image
          src={image}
          width="100%"
          height="100%"
          maxWidth={150}
          alt={`logo-${provider.name}`}
          display={['none', null, 'block']}
        />
      </Div>

      <Div display="flex" alignItems="center">
        <Price
          value={priceInfo.total}
          label={`per ${getLabel(filters.showPriceMode[0])}`}
          variant="priceMediumProductModal"
        />
        {data.purchasableProduct ? (
          <Button
            onClick={() => handleClick()}
            className="buildButton"
            variant="primarySmall"
          >
            {'Ga verder'}
          </Button>
        ) : (
          <Div textAlign="right" maxWidth={150}>
            Geen samenwerking met verzekeraar
          </Div>
        )}
      </Div>
    </Div>
  );

  return (
    <TabView
      display="flex"
      flexDirection="column"
      startIndex={1}
      selectedTabIndex={selectedTabIndex}
      tabs={tabs}
      tabProps={(selected) => ({
        borderBottom: selected ? '2px solid' : 'none',
        fontWeight: selected ? 'bold' : 'normal',
        borderColor: 'primary',
        color: 'primary',
        mx: 3,
      })}
    >
      {(Tabs, Content) => (
        <>
          <Desktop>{header}</Desktop>

          <Div
            overflow="auto"
            display="flex"
            borderBottom="1px solid"
            borderColor="second.1"
          >
            {Tabs}
          </Div>
          <Div py={4} px={3}>
            {Content}
          </Div>

          <Mobile>
            <Div variant="divider" my={4} />
            {header}
          </Mobile>
        </>
      )}
    </TabView>
  );
};
